import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { environment } from '@env/environment';
import { LoggingService } from '../services/error-logging.service';

@Injectable()
export class UsersAPI {
  constructor(
    private http: HttpClient,
    private logger: LoggingService,
  ) {}

  getData(query: string): Observable<any> {
    return this.http.get(`${environment.app.resources.dashboard}users?${query}`).pipe(
      map((response: any) => {
        // transform your response here
        return response.data;
      }),
      catchError((error: any) => {
        this.logger.logError('Could not fetch data', error, 'error');
        return throwError('Could not fetch data');
      }),
    );
  }

  postData(id: number, data: any): Observable<boolean> {
    return this.http.post(`${environment.app.resources.dashboard}users/${id}`, data).pipe(
      map(() => {
        return true;
      }),
      catchError((error: any) => {
        this.logger.logError('Updating failed', error, 'error');
        return throwError('Updating failed');
      }),
    );
  }

  patchData(id: number, data: any): Observable<boolean> {
    return this.http.patch(`${environment.app.resources.dashboard}users/${id}`, data).pipe(
      map(() => {
        return true;
      }),
      catchError((error: any) => {
        this.logger.logError('Updating failed', error, 'error');
        return throwError('Updating failed');
      }),
    );
  }
  deleteData(id: number, data: any): Observable<boolean> {
    return this.http.delete(`${environment.app.resources.dashboard}users/${id}`, data).pipe(
      map(() => {
        return true;
      }),
      catchError((error: any) => {
        this.logger.logError('deleting failed', error, 'error');
        return throwError('deleting failed');
      }),
    );
  }
}
